import { BindAll } from 'lodash-decorators'
import { $service } from '@xt/client/experimental/request/service'
import { action, observable, toJS } from 'mobx'
import type { SettingsItemIcon } from '@xt/client/entities/user/types.d'
import { EnumMyCenterPrivacyConfig } from '@xt/client/enums/my'
import { EnumApiUser } from '@xt/client/api/user'
import { CodeFLAG } from '@xt/client/dataSource/my'

export type PrivacyConfig = {
  icon: SettingsItemIcon
  type: EnumMyCenterPrivacyConfig
  mask: number
  enable: boolean
  title: string
  description: string
}

@BindAll()
export class MySettingsPrivacyController {
  @observable isReady: boolean = false
  @observable list: any[] = []

  public async loadPrivacySettings(id: string) {
    if (this.isReady) return

    const [, mask] = await $service<number>({
      method: 'GET',
      url: EnumApiUser.GetConfig,
      data: {
        id
      }
    })

    if (typeof mask === 'number') {
      this.setList(mask)
      this.setReady(true)
    }
  }

  public async onChangePrivacySettings(setting: PrivacyConfig) {
    let result: number = 0

    const rollbackList = toJS(this.list)

    const nextList = this.list.map(old => {
      if (old.type === setting.type) {
        return {
          ...old,
          enable: !setting.enable
        }
      }

      return old
    })

    nextList.forEach(_item => {
      if (_item.enable === true) {
        result |= _item.mask
      }
    })

    this.updateList(nextList)

    const [, success] = await $service<boolean>({
      method: 'POST',
      url: EnumApiUser.UpdateConfig,
      params: {
        configFlag: result
      }
    })

    if (success === true) {
      return true
    }

    // 回滚
    this.updateList(rollbackList)
    return false
  }

  @action
  private updateList(newList: Array<PrivacyConfig>) {
    this.list = newList
  }

  @action
  private setList(mask: number) {
    this.list = [
      {
        type: 'Homework',
        icon: 'wechat',
        mask: CodeFLAG.Homework_Flag,
        title: '作业',
        description: '桐学可查看我的作业列表',
        enable: !!(mask & CodeFLAG.Homework_Flag)
      },
      {
        type: 'Reward',
        icon: 'wechat',
        mask: CodeFLAG.Reward_Flag,
        title: '作品',
        description: '桐学可查看我的作品列表',
        enable: !!(mask & CodeFLAG.Reward_Flag)
      },
      {
        type: 'Daily',
        icon: 'wechat',
        mask: CodeFLAG.Daily_Flag,
        title: '日常',
        description: '桐学可查看我的日常列表',
        enable: !!(mask & CodeFLAG.Daily_Flag)
      },
      {
        type: 'Collect',
        icon: 'wechat',
        mask: CodeFLAG.Collect_Flag,
        title: '收藏',
        description: '桐学可查看我的收藏列表',
        enable: !!(mask & CodeFLAG.Collect_Flag)
      },
      {
        type: 'Experience',
        icon: 'wechat',
        mask: CodeFLAG.Experience_Flag,
        title: '精进值',
        description: '桐学可看到我的精进值等级',
        enable: !!(mask & CodeFLAG.Experience_Flag)
      },
      // {
      //   type: 'Certificate',
      //   icon: 'wechat',
      //   mask: CodeFLAG.Certificate_Flag,
      //   title: '证书',
      //   description: '桐学可查看我获得的证书',
      //   enable: !!(mask & CodeFLAG.Certificate_Flag)
      // },
      // {
      //   type: 'Award',
      //   icon: 'wechat',
      //   mask: CodeFLAG.Award_Flag,
      //   title: '获奖',
      //   description: '桐学可查看我的获奖情况',
      //   enable: !!(mask & CodeFLAG.Award_Flag)
      // },
      {
        type: 'Learning',
        icon: 'wechat',
        mask: CodeFLAG.Learning_Flag,
        title: '正在学习',
        description: '桐学可查看我正在学习的课程',
        enable: !!(mask & CodeFLAG.Learning_Flag)
      },
      {
        type: 'StudyData',
        icon: 'wechat',
        mask: CodeFLAG.StudyData_Flag,
        title: '学习数据',
        description: '桐学可查看我的学习情况数据',
        enable: !!(mask & CodeFLAG.StudyData_Flag)
      }
    ]
  }

  @action
  private setReady(ready: boolean) {
    this.isReady = ready
  }

  @action
  public reset() {
    this.isReady = false
    this.list = []
  }
}
